<template>
  <div class="excellentcourse">
    <headers ref="header" style="position: fixed; width: 100%; z-index: 9999" />
    <!-- 数学 逻辑 语法 阅读 -->
    <el-tabs class="theelement" v-model="activeName">
      <el-tab-pane label="数学" name="first">
        <!-- 1 -->
        <div class="one">
          <div>
            <div class="cardRight1" id="cardRight11" style="none">
              <video
                src="https://cdn.scoreupup.com/static/video/1.mp4"
                class="cardVideo"
                controls
              ></video>
            </div>
          </div>
          <div>
            <div class="cardRight1">
              <video
                src="https://cdn.scoreupup.com/static/video/2.mp4"
                class="cardVideo"
                controls
              ></video>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="逻辑" name="second">
        <!-- 2 -->
        <div class="two">
          <div>
            <div class="cardRight2">
              <video
                src="https://cdn.scoreupup.com/static/video/5.mp4"
                class="cardVideo"
                controls
              ></video>
            </div>
          </div>
          <div>
            <div class="cardRight2">
              <video
                src="https://cdn.scoreupup.com/static/video/6.mp4"
                class="cardVideo"
                controls
              ></video>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="语法" name="third">
        <!-- 3 -->
        <div class="three">
          <div>
            <div class="cardRight3">
              <video
                src="https://cdn.scoreupup.com/static/video/3.mp4"
                class="cardVideo"
                controls
              ></video>
            </div>
          </div>
          <div>
            <div class="cardRight3">
              <video
                src="https://cdn.scoreupup.com/static/video/4.mp4"
                class="cardVideo"
                controls
              ></video>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="阅读" name="fourth">
        <!-- 4 -->
        <div class="four">
          <div>
            <div class="cardRight4">
              <video
                src="https://cdn.scoreupup.com/static/video/7.mp4"
                class="cardVideo"
                controls
              ></video>
            </div>
          </div>
          <div>
            <div class="cardRight4">
              <video
                src="https://cdn.scoreupup.com/static/video/8.mp4"
                class="cardVideo"
                controls
              ></video>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <div></div>
  </div>
</template>

<script>
import api from "@/api/activeTest.js";
import $ from "jquery";
import baseUrl from "@/api/common.js";
import headers from "@/components/header.vue";
export default {
  components: {
    headers,
  },
  data() {
    return {
      navCodes: require("@/assets/login/navCode.png"),
      herderTits: {
        color: "#666666",
      },
      headerBack: {
        background: "#ffffff",
      },
      headerIcon: require("@/assets/home/headerNav.png"),
      n: 0,
      //switchTab 数学 逻辑 语法 阅读
      classCourse: [
        {
          sbuject: "数学",
          type: 0,
        },
        {
          sbuject: "逻辑",
          type: 1,
        },
        {
          sbuject: "语法",
          type: 2,
        },
        {
          sbuject: "阅读",
          type: 3,
        },
      ],
      arrActive: [],
      // courseInfo: [],
      base: baseUrl,
      activeName: "second",
    };
  },
  methods: {
    switchSbuject(type) {
      this.n = type;
    },
  },
  mounted() {
    $("html,body").scrollTop(0);
    this.$refs.header.isTop = false;
    this.$refs.header.headerBack.background = "#ffffff";
    this.$refs.header.herderTits.color = "#666666";
    this.$refs.header.headerIcon = require("@/assets/home/headerNav.png");
    this.$refs.header.loginButton = {
      background: "#618aff",
      color: "#fff",
    };
    this.$refs.header.phoneButton = {
      color: "#618aff",
      border: "1px solid #618aff",
    };
  },
};
</script>
<style scoped>
@import "../../assets/css/excellentcourse.css";
</style>



// WEBPACK FOOTER //
// src/view/excellentCourse/excellentcourse.vue